import React from 'react';
import { TextField } from '@mui/material';
import {
  nowDatetimeLocal,
  createFutureDatetimeChangeHandler,
  getFutureDatetimeInputProps,
  FUTURE_DATETIME_HELPER,
} from '../../utils/datetimeLocal';

/**
 * datetime-local field that blocks past selection (min = now or `minDatetime`).
 */
const FutureDatetimeTextField = ({
  value,
  onChange,
  minDatetime,
  disablePast = true,
  showFutureHelper = true,
  helperText,
  inputProps: inputPropsProp,
  InputLabelProps,
  ...rest
}) => {
  const min = minDatetime ?? nowDatetimeLocal();
  const handleChange = disablePast
    ? createFutureDatetimeChangeHandler(onChange, min)
    : (e) => onChange(e.target.value);

  const resolvedHelper =
    helperText !== undefined
      ? helperText
      : showFutureHelper
        ? FUTURE_DATETIME_HELPER
        : undefined;

  return (
    <TextField
      type="datetime-local"
      value={value ?? ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      inputProps={getFutureDatetimeInputProps(min, inputPropsProp)}
      helperText={resolvedHelper}
      {...rest}
    />
  );
};

export default FutureDatetimeTextField;
